// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g90zQx27hG7Y_zrzq9CB {
  border-radius: 12px;
  border: 0.2px solid rgb(217, 217, 217);
  box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 8px 0px;
  background-color: rgb(255, 255, 255);
}
.g90zQx27hG7Y_zrzq9CB .ilN8XOadDxTaJkdieAwV {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px 8px 24px;
  border-bottom: solid 2px #d4d4d4;
}
.g90zQx27hG7Y_zrzq9CB .ilN8XOadDxTaJkdieAwV .aGPTZ9ruPeH8aMjThaCJ {
  font-size: 18px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./packages/common/utils/components/src/lib/Card/Card.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,sCAAA;EACA,+CAAA;EAEA,oCAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,gCAAA;AAAJ;AAEI;EACE,eAAA;EACA,gBAAA;AAAN","sourceRoot":""}]);
// Exports
export var card = `g90zQx27hG7Y_zrzq9CB`;
export var cardHeader = `ilN8XOadDxTaJkdieAwV`;
export var cardTitle = `aGPTZ9ruPeH8aMjThaCJ`;
export default ___CSS_LOADER_EXPORT___;
